import { mapValues, snakeCase, isObject, mapKeys } from 'lodash-es';

export function applySnakeCaseToKeysRecursively<T extends Object>(object: T): T {
	return <T><unknown>mapValues(
		mapKeys(object, (_, key) => snakeCase(key)),
		value => isObject(value) ? applySnakeCaseToKeysRecursively(value) : value,
	);
}
